module.exports = __webpack_public_path__ + "img/table-asana-icon.c74be3a1.svg";